import { useFlag } from '@/feature/feature-flags'

export const useIsSubbie = () => useFlag('featureIsSubbie', false)
